import {RightsMapper} from "./RightsMapper.ts";
import {useAuth} from "react-oidc-context";
import type {SlotProps} from "@mui/material";
import type {Permission, Resource} from "./RightsSystem.ts";

export interface Authorization {
    readOnly: boolean;
    readOnlyProps: SlotProps<any, any, any>;
    canList: boolean
    canRead: boolean;
    canCreate: boolean;
    canWrite: boolean;
    canDelete: boolean;
}

const hasRight = (permission: Permission, authorities: string[]) => {
    if (RightsMapper.hasMapping(permission)) {
        const mappedAuth = RightsMapper.getMapping(permission);
        if (mappedAuth) {
            return authorities.includes(mappedAuth);
        }
    }
    return false;
};

export const useAuthorize = (target: Resource): Authorization => {
    const auth = useAuth();
    const authorities = auth.user?.profile.authorities as string[] || [];

    if (RightsMapper.isSuperAdmin(authorities)) {
        return {readOnly: false, readOnlyProps: undefined, canList: true, canRead: true, canCreate: true, canWrite: true, canDelete: true};
    }

    const canRead = hasRight(`${target}_read`, authorities);
    const canCreate = hasRight(`${target}_create`, authorities);
    const canList = hasRight(`${target}_list`, authorities);
    const canWrite = hasRight(`${target}_write`, authorities);
    const canDelete = hasRight(`${target}_delete`, authorities);

    const readOnly = !canWrite;
    const readOnlyProps = {
        input: {
            readOnly
        }
    };

    return { readOnly, readOnlyProps, canList, canRead, canCreate, canWrite, canDelete };
};
